import useInitializeCustomerProfileAdvancedForm from './useInitializeCustomerProfileAdvancedForm'

export default useInitializeCustomerProfileAdvancedForm
